/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
// import { withSnackbar } from "notistack";
// import { Button } from "@material-ui/core";
// import { verifyObject } from "utilities/utils";
import RedirectComponent from "../components/RedirectComponent/RedirectComponent";
import metadata from "../metadata.json";
import RoutesArray from "./RoutesArray";
import RestrictedRoutes from "../hoc/RestrictedRoutes";
import PrivateRoutes from "../hoc/PrivateRoutes";
import Loader from "../components/common/PageLoader";
import { verifyObject } from "utilities/utils";
// import { ToastContainer } from "react-toastify";
const AppRoutes = (props) => {
  useEffect(() => {
    // const action = (key) => (
    //   <Fragment>
    //     <Button
    //       onClick={() => {
    //         window.location.reload(true);
    //       }}
    //       className="met-refresh"
    //     >
    //       Refresh
    //     </Button>
    //     <Button
    //       onClick={() => {
    //         props.closeSnackbar(key);
    //       }}
    //       className="met-refresh"
    //     >
    //       Dismiss
    //     </Button>
    //   </Fragment>
    // );

    if (
      process.env.REACT_APP_ENV === "prod" &&
      process.env.NODE_ENV === "production"
    ) {
      let VERSION = `${verifyObject(
        metadata,
        "prod.prodBuildMajor",
        ""
      )}.${verifyObject(metadata, "prod.prodBuildMinor", "")}.${verifyObject(
        metadata,
        "prod.prodBuildRevision",
        ""
      )} | ${verifyObject(metadata, "prod.prodBuildTag", "")}`;

      console.log("APP CURRENT VERSION", VERSION);
      if (JSON.parse(localStorage.getItem("APP_VERSION")) === null) {
        localStorage.setItem("APP_VERSION", JSON.stringify(VERSION));
        // setVersion(VERSION);
      } else {
        let currentAppVersion = JSON.parse(localStorage.getItem("APP_VERSION"));
        if (currentAppVersion !== VERSION) {
          // props.enqueueSnackbar("New app update is available !", {
          //   //   autoHideDuration: 3000,
          //   variant: "success",
          //   persist: true,
          //   action,
          // });
          localStorage.setItem("APP_VERSION", JSON.stringify(VERSION));
          // setVersion(VERSION);
        }
      }
    }

    if (
      process.env.REACT_APP_ENV === "dev" &&
      process.env.NODE_ENV === "production"
    ) {
      localStorage.removeItem("APP_VERSION");

      let VERSION = `${verifyObject(
        metadata,
        "dev.devBuildMajor",
        ""
      )}.${verifyObject(metadata, "dev.devBuildMinor", "")}.${verifyObject(
        metadata,
        "dev.devBuildRevision",
        ""
      )} | ${verifyObject(metadata, "dev.devBuildTag", "")}`;
      console.log("APP CURRENT VERSION", VERSION);
      if (JSON.parse(localStorage.getItem("APP_VERSION")) === null) {
        localStorage.setItem("APP_VERSION", JSON.stringify(VERSION));
        // setVersion(VERSION);
      } else {
        let currentAppVersion = JSON.parse(localStorage.getItem("APP_VERSION"));
        if (currentAppVersion !== VERSION) {
          // props.enqueueSnackbar("New app update is available !", {
          //   //   autoHideDuration: 3000,
          //   variant: "success",
          //   persist: true,
          //   action,
          // });
          localStorage.setItem("APP_VERSION", JSON.stringify(VERSION));
          // setVersion(VERSION);
        }
      }
    }

    if (
      process.env.REACT_APP_ENV === "stage" &&
      process.env.NODE_ENV === "production"
    ) {
      let VERSION = `${verifyObject(
        metadata,
        "stage.stageBuildMajor",
        ""
      )}.${verifyObject(metadata, "stage.stageBuildMinor", "")}.${verifyObject(
        metadata,
        "stage.stageBuildRevision",
        ""
      )} | ${verifyObject(metadata, "stage.stageBuildTag", "")}`;

      // console.log("APP CURRENT VERSION", versionDetail, VERSION);
      if (JSON.parse(localStorage.getItem("APP_VERSION")) === null) {
        localStorage.setItem("APP_VERSION", JSON.stringify(VERSION));
        // setVersion(VERSION);
      } else {
        let currentAppVersion = JSON.parse(localStorage.getItem("APP_VERSION"));
        console.log("APP CURRENT VERSION", currentAppVersion);
        console.log("APP NEW VERSION", VERSION);

        if (currentAppVersion !== VERSION) {
          // props.enqueueSnackbar("New app update is available !", {
          //   //   autoHideDuration: 3000,
          //   variant: "success",
          //   persist: true,
          //   action,
          // });
          localStorage.setItem("APP_VERSION", JSON.stringify(VERSION));
          // setVersion(VERSION);
        }
      }
    }

    return () => {};
  }, []);
  return (
    <Fragment>
      {/* <ToastContainer
        enableMultiContainer={true}
        containerId={"container_main"}
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <BrowserRouter>
        <Routes>
          {RoutesArray.map((route, index) => {
            let ComponentName = route.element;
            if (route.isPrivateRoute) {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <PrivateRoutes>
                        <ComponentName />
                      </PrivateRoutes>
                    </React.Suspense>
                  }
                />
              );
            }

            if (route.isRestrictedRoute) {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <RestrictedRoutes>
                        <ComponentName />
                      </RestrictedRoutes>
                    </React.Suspense>
                  }
                />
              );
            }

            if (route.isOpenRoute) {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ComponentName />
                    </React.Suspense>
                  }
                />
              );
            }
            return null;
          })}
          <Route exact path="*" element={<RedirectComponent />} />
        </Routes>
      </BrowserRouter>
    </Fragment>
  );
};

export default AppRoutes;
